import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Paper,
  TableFooter,
  TablePagination,
  IconButton,
  withStyles,
  Button,
} from '@material-ui/core'

import moment from 'moment'

import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import SearchField from '../common/SearchField'

class WmDispatchErrorLogsTab extends Component {
  state = {
    term: '',
    wmDispatchErrorLogs: [],
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
  }

  componentDidMount() {}

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value })
  }

  onChangeTerm = (e) => {
    this.setState({ term: e.target.value })
  }

  onSearch = (e) => {
    console.log(e)
  }

  handleChange = (e) => {
    this.setState({ checked: e.target.checked })
  }

  render() {
    const { wmDispatchErrorLogs } = this.state
    const { page, rowsPerPage, rowsPerPageOptions } = this.state
    return (
      <div>
        <Paper elevation={0} className={`tab-paper`}>
          <Typography variant="title">Error Logs</Typography>
          <Grid container className="margin-top-medium remove-margin">
            <Grid item xs={12} sm={4}>
              <div className="category-rightside">
                <SearchField
                  onSearch={this.onSearch}
                  onChange={this.onChangeTerm}
                  value={this.state.term}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}></Grid>
            <Grid item xs={12} sm={2} style={{ paddingRight: 3 }}>
              <Button variant="outlined" color="primary" className="b-outline" fullWidth>
                <span className="button-text">Export to CSV</span>
              </Button>
            </Grid>
          </Grid>
          <Grid container className="full-width">
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="margin-top-small" elevation={1}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Timestamp</TableCell>
                      <TableCell>Shop Name</TableCell>
                      <TableCell>Order #</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Cause</TableCell>
                      <TableCell>BLAZE Message</TableCell>
                      <TableCell>WM Dispatch Error</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(wmDispatchErrorLogs &&
                      wmDispatchErrorLogs.length &&
                      wmDispatchErrorLogs
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((errorLog, i) => {
                          return (
                            <TableRow key={i}>
                              <TableCell>
                                {moment(errorLog.created).format('MM/DD/YYYY hh:mm A')}
                              </TableCell>
                              <TableCell>{errorLog.errorType}</TableCell>
                              <TableCell>{errorLog.cause}</TableCell>
                              <TableCell>
                                {errorLog.message.replace('OnFleet', 'Onfleet')}
                              </TableCell>
                              <TableCell> </TableCell>
                            </TableRow>
                          )
                        })) || (
                      <TableRow>
                        <TableCell colSpan={12}>
                          <Typography className="text-center">
                            No Error Logs for this company.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        colSpan={3}
                        count={wmDispatchErrorLogs.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActionsWrapped}
                        rowsPerPageOptions={rowsPerPageOptions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </Paper>
            </Grid>
          </Grid>
        </Paper>
      </div>
    )
  }
}

export default connect(({ dispatch }) => ({ dispatch }))(WmDispatchErrorLogsTab)

/* ------ PAGINATION ------ */
const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
  },
})

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(event, 0)
  }

  handleBackButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page - 1)
  }

  handleNextButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page + 1)
  }

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
    )
  }

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    )
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
}

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
  TablePaginationActions,
)



// WEBPACK FOOTER //
// ./src/components/WmDispatch/WmDispatchErrorLogsTab.js